<button type="button" (click)="share()" class="btn lightbtn" style="display: flex; width: 100%">
  <i class="fas fa-share" style="margin-right: 5px; margin-top: 4px"></i> {{ 'Share' | translate }}
</button>

<p-dialog
  header="SHARE"
  [(visible)]="displayShare"
  [style]="{ minWidth: '30vw', maxWidth: '90vw' }"
  [baseZIndex]="10000"
>
  <div class="share-icons">
    <div class="row">
      <div class="col-md-3 col-3 text-center pt-2 pb-2" (click)="shareLink(key)" *ngFor="let key of shareKeys">
        <i [class]="shareButtons[key].icon"></i>
      </div>
    </div>
    <p-toast position="bottom" key="sharesucess"></p-toast>
    <div class="row pt-3 margin-auto" *ngIf="data">
      <div class="input-group mb-3">
        <input type="text" class="form-control link" [placeholder]="data.href" disabled />
        <div class="input-group-append" (click)="copy()">
          <span class="input-group-text copy-link">{{ 'CopyLink' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
